/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import { useState } from 'react'
import './KhuyenMai.scss'

function KhuyenMai () {
  const [tab, settab] = useState('ทั้งหมด')
  const datahead = [
    {
      name: 'ทั้งหมด',
      textuppercase: 'textupper'
    },
    // {
    //   name: 'Khuyến Mãi Nạp',
    //   textuppercase: ''
    // },
    // {
    //   name: 'Hoàn Trả',
    //   textuppercase: ''
    // },
    // {
    //   name: 'Casino',
    //   textuppercase: ''
    // },
    // {
    //   name: 'Thể Thao',
    //   textuppercase: ''
    // },
    // {
    //   name: 'Nổ hũ',
    //   textuppercase: ''
    // },
    // {
    //   name: 'Đá gà',
    //   textuppercase: ''
    // }
  ]

  const data = [
    '/caidat/bannerkm.jpg',
    '/caidat/bannerkm_1.png',
    '/caidat/bannerkm_2.png',
    '/caidat/bannerkm_3.png'
  ]
  return (
    <>
      <div className='activity_category_mobile_tab'>
        {datahead.map((item, index) => (
          <button
            className={`activity_category_mobile_tab_btn ${
              tab === item.name ? 'activity_category_mobile_tab_btn_active' : ''
            } `}
            key={index}
            onClick={() => settab(item.name)}
          >
            <span className={item.textuppercase}>{item.name}</span>
          </button>
        ))}
      </div>
      <div className='activity_category_mobile_content'>
        {data.length > 0 ? (
          data.map((item, index) => (
            <a className='activity_category_mobile_content_item' key={index}>
              <div>
                <img
                  src={item}
                  alt=''
                  className='activity_category_mobile_content_item_img'
                />
              </div>
            </a>
          ))
        ) : (
          <div className='no_data_km'>
            <img src='/caidat/nocogi.png' alt='' />
            <span>Không có khuyến mãi</span>
          </div>
        )}
      </div>
      <div className='footer_vh'></div>
    </>
  )
}

export default KhuyenMai
